// extracted by mini-css-extract-plugin
export var container = "DownloadCard-module--container--1f75f";
export var content = "DownloadCard-module--content--0ae0f";
export var icon = "DownloadCard-module--icon--eccb1";